'use client';

import { useContext, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import Login, { LoginProps } from 'components/gruenland/organisms/authentication/login';
import { AccountContext } from 'context/account';
import Redirect from 'helpers/redirect';
import { Reference } from 'types/reference';
import { TasticProps } from 'frontastic/tastics/types';

const YggdrasilAccountLoginTastic = ({ data }: TasticProps<LoginProps>) => {
  const searchParams = useSearchParams();

  const lvp = searchParams.get('lvp');

  //redirection link after user is logged in
  const redirectLink = useMemo(() => {
    const accountLink: Reference = { type: 'link', link: '/account' };
    const lastVisitedPage = lvp ? `/${lvp}` : accountLink;
    return lastVisitedPage;
  }, [lvp]);

  const { loggedIn, login, requestConfirmationEmail, requestPasswordReset } = useContext(AccountContext);

  if (loggedIn) return <Redirect target={redirectLink} />;

  return (
    <div className="mb-9 md:mb-[56px] lg:mb-[84px]">
      <Login
        {...data}
        login={login}
        requestConfirmationEmail={requestConfirmationEmail}
        requestPasswordReset={requestPasswordReset}
      />
    </div>
  );
};

export default YggdrasilAccountLoginTastic;
